import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { WorkflowTask } from '../models/workflow-task';
import { KeyValue } from '../models/key-value';
import { ServiceConnection } from '../models/service-connections';

@Component({
    selector: 'app-workflow-task',
    templateUrl: './workflow-task.component.html',
    styleUrls: ['./workflow-task.component.css'],
    standalone: false
})
export class WorkflowTaskComponent implements OnInit {

  @Input() wfTask!: WorkflowTask;
  @Input() serviceConnections: ServiceConnection[] = [];
  @ViewChild(MatSort) sort!: MatSort;

  constructor() { }

  public dataSource = new MatTableDataSource<KeyValue>();
  displayedColumns = ['key', 'value'];

  ngOnInit(): void {
    this.dataSource.data = this.wfTask.inputs;
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
  }

  getStatus(status: string) {
    let classString = '';
    switch (status) {
      case 'added':
        classString += 'green';
        break;
      case 'deleted':
        classString += 'red';
        break;
      case 'edited':
        classString += 'blue';
        break;
      default:
        classString += 'gray';
        break;
    }
    return classString;
  }

  replaceSpnText(value: string): string {
    const matchingServiceConnection = this.serviceConnections.find(sc => sc.id === value);
    return matchingServiceConnection ? matchingServiceConnection.name : value;
  }
}
